export default {
  "HitPaw Online Audio Converter": "HitPaw Online-Audiokonverter",
  "Convert audios to MP3, AAC, FLAC, WMA and more formats for free.": "Audio kostenlos in MP3, AAC, FLAC, WMA und weitere Formate konvertieren.",
  'HitPaw Online Image Converter': 'HitPaw Online-Bildkonverter',
  'Convert images to JPG, PNG, BMP, TIFF and more formats for free.': 'Bilder kostenlos in JPG, PNG, BMP, TIFF und weitere Formate konvertieren .',
  'HitPaw Online Video Converter': 'HitPaw online Videokonverter',
  'Convert videos to any formats as your requirements.': 'Konvertieren Sie Videos in ein Format Ihrer Wahl.',
  'Add More Files': 'Mehrere Dateien hinzufügen',
  'Convert to': 'Wird konvertiert in',
  'Ready': 'Bereit',
  'Converting': 'Wird konvertiert',
  'Video': 'Video',
  'Audio': 'Audio',
  'Image': 'Bild',
  'Retry': 'Erneut Versuchen',
  'Download All': 'Alles herunterladen',
  'Download Desktop': 'Desktop herunterladen',
  'Continue Editing': 'Fortfahren',
  'Convert': 'Konvertieren',
  'Cut': 'Schneiden',
  'Speed': 'Geschwindigkeit',
  'Crop & Rotate': 'Zuschneiden & Drehen',
  'Resize': 'Größe ändern',
  'Extract': 'Extrakt',
  'Add Music': 'Musik hinzufügen',
  'Subtitles': 'Untertitel',
  'Merge': 'Zusammenlegen',
  'Watermark Remover': 'Wasserzeichen entfernen',
  'Add Watermark': 'Wasserzeichen hinzufügen',
  'Please select a file to use': 'Bitte wählen Sie eine Datei aus, um {{work}} zu verwenden',
  'Batch Processing': 'Batch Processing',
};
